var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-success"},[_c('van-image',{staticClass:"mb20",attrs:{"width":"160","height":"128","src":require('@/assets/images/income/sign-success.png')}}),_vm._v(" "),_c('p',[_vm._v("免密授权签约成功。快去创建您的专属直播吧~")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }